import { LayoutType } from 'src/app/core';
import { LayoutConfigBuilder } from 'src/app/layouts/default-layout/builders/layout-config.builder';
import { LayoutConfigPresets } from 'src/app/layouts/default-layout/models/layout-structures.models';

export enum ReflectionsRoutesConfig {
	REFLECTIONS_BASE_URL = 'reflections',
	MESSAGES_SEGMENT = 'messages',
	CHATS_SEGMENT = 'chats',
	NEW_SEGMENT = 'new'
}

const layoutConfig = new LayoutConfigBuilder(LayoutConfigPresets.minimal)
	.setBodyCssClasses(['bg--gray-lighter'])
	.showDefaultFooter(false)
	.setContentCssClasses(['wrap--no-subheader', 'wrap--action-footer'])
	.setHeaderCssClasses(['header--no-scroll'])
	.setAdminWrapCssClasses(['admin-wrap--no-sidenav'])
	.build();

export const pageData = {
	layout: LayoutType.DEFAULT,
	layoutConfig: layoutConfig
};
